export default {"src":"/_next/static/media/arrowThumbnail.67b3fce5.svg","height":23,"width":9};